
import env from './env';

const ep = (path = '/', subdomain = 'ruby-on-rails-api') => (
  env.isDevelopment() ?
    `http://${subdomain}.dev.localhost:3001${path}` :
    `https://${subdomain}.herokuapp.com${path}`
);

const API = {
  ping: () => {
    return fetch(ep('/messages'))
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        // console.log(`API ping, list length: ${json.length}`);

        return `API ping, list length: ${json.length}`;
      })
      .catch((error) => {
        // console.log(
        //   'There has been a problem with your fetch operation...', error
        // );
        return error;
      });
  },

  retrieve: () => {
    return fetch(ep('/messages'))
      .then((response) => {
        return response.json();
      });
      // .catch((error) => {
      //   console.log(
      //     'There has been a problem with your fetch operation...', error
      //   );
      //   return error;
      // });
  },

  message: ({ from, subject, text }) => {
    const msg = {
      message: {
        from,
        // to: 'react-recepient@example.com',
        subject,
        text
      }
    };

    return fetch(ep('/messages'), {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },

      method: 'POST',
      body: JSON.stringify(msg)
    })
    .then((response) => {
      return response.json();
    });
    // .catch((error) => {
    //   console.log(
    //     'There has been a problem with your fetch operation...', error
    //   );
    //   throw error;
    //   // return error;
    // });
  }
};

export default API;



// WEBPACK FOOTER //
// ./src/lib/api.js